var map = {
	"./AcidBlade.mp4": 42978,
	"./AcidClub.mp4": 10007,
	"./AcidScepter.mp4": 36406,
	"./AcidSword.mp4": 53371,
	"./BlackRose.mp4": 1192,
	"./BloodLustSword.mp4": 93456,
	"./BodhiSword.mp4": 6194,
	"./BronzeDragonSlayer.mp4": 39418,
	"./BubbleUmbrella.mp4": 46918,
	"./CakePop.mp4": 74199,
	"./DeadlyThorn.mp4": 99887,
	"./DemonicBlade.mp4": 19458,
	"./DragonBlade.mp4": 53270,
	"./DragonHowl.mp4": 95675,
	"./ElementsBlade.mp4": 68902,
	"./EmeraldScythe.mp4": 2651,
	"./FloralWeapon.mp4": 22148,
	"./GoldenDagger.mp4": 6508,
	"./GoldenDragonSlayer.mp4": 38757,
	"./GraspofLove.mp4": 70833,
	"./JadeBlade.mp4": 52085,
	"./JadeSword.mp4": 41063,
	"./KingCatStaff.mp4": 35162,
	"./Knife.mp4": 72050,
	"./LavaBlade.mp4": 95559,
	"./LightSword.mp4": 15312,
	"./PhoenixDream(Sparkle).mp4": 32573,
	"./PinkyBlade.mp4": 41092,
	"./PinkyClub.mp4": 14472,
	"./PinkySword.mp4": 13921,
	"./RedBuriedBlade.mp4": 42060,
	"./RedCurse.mp4": 19618,
	"./SilverDragonSlayer.mp4": 84690,
	"./StarGazerSword.mp4": 84532,
	"./SwordofElements.mp4": 95869,
	"./ThorFireHammer.mp4": 88095,
	"./ThorIceHammer.mp4": 2664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19354;